export const TOOLTIP_TEXTS = {
  TVL: 'Total value locked in the vault / Percentage of the vault’s total capacity',
  CURRENT_APY: 'The current annual return (percentage yield) based on current interest rates',
  TARGET_APY:
    'The target annual return (percentage yield) based on the desired target interest rate',
}
